

import ContactFooterMainSection from "../PageElements/ContactFooterPageElement/ContactFooterMainSection";
import ConsultSection from "../PageElements/HomePageElements/ConsultSection";

export default function ContactUs() {
    return (
        <>
            <ContactFooterMainSection/>
            {/* <ServiceSection /> */}
            <ConsultSection/>
        </>
    )
}